//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 20/08/2024
// Version : 1
// Description : pantalla de control de deposito del panel de tab_checklist,
// que tiene el auditor para ver el checklist y revisarlo
// (contiene resultado_tabla adentro que muestra el resultado)
//------Changes --------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/

import React, { useState, useEffect, useMemo } from "react";
import { UrlApi } from "../../../services/apirest";
import Navbar from "../../Navbar";
import {
  Container,
  Box,
  Typography,
  IconButton,
  Tooltip,
  createTheme,
  useTheme,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  TextField,
  Grid,
} from "@mui/material";
import Button from "@mui/material/Button";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import { ThemeProvider } from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import Resultado_tabla from "./Resultado_tabla";
import moment from "moment";
import CheckIcon from "@mui/icons-material/Check";
import Dialog_revision from "./Dialog_revision";

function Tabla_check(props) {
  const [resultados, setResultados] = useState({});
  const [resultadosUsuario, setResultadosUsuario] = useState({});
  const [tabla, setTabla] = useState(true);
  const [datosResultados, setDatosResultados] = useState({});
  const [mostrarResultadoCheck, setMostrarResultadoCheck] = useState(false);
  const [revision, setRevision] = useState(false);
  const [esAuditor, setEsAuditor] = useState(localStorage.getItem("auditor"));
  const [checklistRow, setChecklistRow] = useState();

  // Período aplicado: viene del padre (Tab_checklistResultados), compartido con Panelrrhh.
  // Antes vivía acá con useState propio; por eso se perdía al cambiar de tab.
  const selectedDate = props.periodoAplicado;
  const setSelectedDate = props.setPeriodoAplicado;

  const formattedDate = `${selectedDate}-01`;

  const [fechaString, setFechaString] = useState("");

  useEffect(() => {
    if (datosResultados.fecha) {
      setFechaString(datosResultados.fecha.toString());
    }
  }, [datosResultados]);

  //console.log("fecha STRINg",fechaString);

  // selYear/selMonth: período REALMENTE aplicado (el que trajo los datos de la tabla)
  const [selYear, selMonth] = selectedDate.split("-");

  // pendingMonth/pendingYear: lo que el usuario está eligiendo, todavía sin aplicar.
  // Se aplica (y dispara el fetch) recién al tocar "Buscar".
  const [pendingMonth, setPendingMonth] = useState(selMonth);
  const [pendingYear, setPendingYear] = useState(selYear);

  // Si selectedDate cambia (por Buscar acá o desde la otra tab), sincronizamos los borradores
  useEffect(() => {
    setPendingMonth(selMonth);
    setPendingYear(selYear);
  }, [selectedDate]);

  const handleMonthChange = (event) => {
    setPendingMonth(event.target.value);
  };

  const handlePendingYearChange = (event) => {
    const valor = event.target.value.replace(/\D/g, "").slice(0, 4);
    setPendingYear(valor);
  };

  const handleBuscarPeriodo = () => {
    if (pendingYear.length !== 4) {
      setPendingYear(selYear); // año incompleto/inválido, se descarta el cambio
      return;
    }
    const nuevoPeriodo = `${pendingYear}-${pendingMonth}`;
    setSelectedDate(nuevoPeriodo);

    // Mismo comportamiento que tenía el handleDateChange original:
    // actualiza datosResultados.fecha con el período recién elegido
    setDatosResultados({
      ...datosResultados,
      fecha: moment(nuevoPeriodo, "YYYY-MM").format("YYYY-MM-DD"),
    });
  };

  const handleAnioKeyDown = (event) => {
    if (event.key === "Enter") {
      handleBuscarPeriodo();
    }
  };

  // Lista fija de meses (antes eran solo los últimos 8 meses hacia atrás)
  const monthNumberOptions = [
    { value: "01", label: "Enero" },
    { value: "02", label: "Febrero" },
    { value: "03", label: "Marzo" },
    { value: "04", label: "Abril" },
    { value: "05", label: "Mayo" },
    { value: "06", label: "Junio" },
    { value: "07", label: "Julio" },
    { value: "08", label: "Agosto" },
    { value: "09", label: "Septiembre" },
    { value: "10", label: "Octubre" },
    { value: "11", label: "Noviembre" },
    { value: "12", label: "Diciembre" },
  ];

  const obtenerResultados = () => {
    const year = formattedDate.split("-")[0];
    const month = formattedDate.split("-")[1];

    // Construir la URL con el año y el mes
    const url = `${UrlApi}/estados_evaluacion_comercial/checkCompleto/${year}/${month}`;

    fetch(url)
      .then((data) => data.json())
      .then((data) => setResultados(data));
  };

  useEffect(() => {
    obtenerResultados();
  }, [selectedDate]);

  //*********************** RESULTADOS USUARIOS *********************** //
  const obtenerResultadosUsuario = () => {
    const year = formattedDate.split("-")[0];
    const month = formattedDate.split("-")[1];

    // Construir la URL con el año y el mes
    const url = `${UrlApi}/estados_evaluacion_comercial/checkCompletoUser/${year}/${month}/${localStorage.getItem(
      "user"
    )}`;

    fetch(url)
      .then((data) => data.json())
      .then((data) => setResultadosUsuario(data));
  };

  useEffect(() => {
    if (props.esComercial === true) {
      obtenerResultadosUsuario();
    }
  }, [selectedDate, props.esComercial]);
  // *********************************************************** Tabla ********************************************************************** //
  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "8rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "primary",
    size: "small",
  };

  const tableHeadCellProps = {
    align: "center",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const globalTheme = useTheme();
  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary, //primary color for the table
          info: {
            main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000", //pure black table in dark mode for fun
          },
        },
        typography: {
          button: {
            textTransform: "none", //customize typography styles for all buttons in table by default
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  const initialState = {
    //para inicializar la tabla, y la cantidad de paginas q se ven ej 5
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
    grouping: ["nombre_apellido"],
  };

  const columns = useMemo(
    // TABLA Objetivos
    () => [
      {
        header: "Comercial",
        accessorKey: "nombre_apellido",
        size: 110,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Sucursal",
        accessorKey: "nombre",
        size: 110,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Cumple",
        accessorKey: "cumple",
        size: 90,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "No Cumple",
        accessorKey: "nocumple",
        size: 90,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Fecha",
        accessorFn: (datosResultados) => {
          return moment(datosResultados.fecha, "YYYY-MM-DD").format("MM-YYYY");
        },
        size: 90,
        muiTableBodyCellProps: { align: "center" },
      },
      {
        header: "Auditado",
        accessorKey: "auditado",
        size: 110,
        muiTableBodyCellProps: { align: "left" },
      },
      // { header: "Fecha", accessorKey: "fecha_auditado", size: 110 },
      {
        header: "Fecha Auditoría",
        accessorFn: (datosResultados) => {
          return datosResultados.fecha_auditado
            ? moment(datosResultados.fecha_auditado, "YYYY-MM-DD").format(
              "DD-MM-YYYY"
            )
            : "-";
        },
        size: 110,
        muiTableBodyCellProps: { align: "center" },
      },
    ],
    []
  );
  const handleClickMostrar = (row) => {
    setDatosResultados(row);
    setTabla(false);
    setMostrarResultadoCheck(true);
  };

  const handleVolverMostrar = () => {
    setRevision(false);
    setTabla(true);
    setMostrarResultadoCheck(false);
    obtenerResultados();
  };

  return (
    <div>
      <Navbar />
      <br></br>
      {tabla ? (
        <Container maxWidth="xl" mt={1} mb={2}>
          {resultados ? (
            <Box boxShadow={3}>
              <ThemeProvider theme={tableTheme}>
                <MaterialReactTable
                  enableColumnResizing
                  columns={columns}
                  data={
                    props.esComercial === true ? resultadosUsuario : resultados
                  }
                  initialState={initialState}
                  positionActionsColumn="last"
                  enableExpandAll={false}
                  enableToolbarInternalActions={true}
                  muiTableHeadCellProps={tableHeadCellProps}
                  muiTableBodyCellProps={({ row }) => ({
                    //  align: "left",
                    sx: {
                      backgroundColor:
                        row.original.auditado === "No" ? "#efc3c3" : "#b3e6b3",
                      color: "black",
                      borderColor: "black",
                    },
                  })}
                  enableColumnActions={false}
                  muiSearchTextFieldProps={muiSearchTextFieldProps}
                  enableDensityToggle={false}
                  renderTopToolbarCustomActions={() => (
                    <>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm="auto">
                          <Typography fontSize={{ xs: 16, sm: 26 }}>
                            Control de Depósito
                          </Typography>
                          <Typography fontSize={14} color="text.secondary">
                            Mostrando período:{" "}
                            <strong>
                              {monthNumberOptions.find(
                                (m) => m.value === selMonth
                              )?.label || selMonth}{" "}
                              {selYear}
                            </strong>
                          </Typography>
                        </Grid>
                        <Grid item xs={6} sm="auto">
                          <FormControl
                            focused
                            color="primary"
                            required
                            size="small"
                            sx={{
                              minWidth: { xs: "10%", sm: 160 },
                            }}
                          >
                            <InputLabel id="mes">Mes</InputLabel>
                            <Select
                              required
                              variant="outlined"
                              name="mes"
                              value={pendingMonth}
                              onChange={handleMonthChange}
                              label="Mes"
                              labelId="mes"
                            >
                              {monthNumberOptions.map((elemento) => (
                                <MenuItem
                                  key={elemento.value}
                                  value={elemento.value}
                                >
                                  {elemento.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={6} sm="auto">
                          <TextField
                            required
                            focused
                            color="primary"
                            size="small"
                            variant="outlined"
                            label="Año"
                            value={pendingYear}
                            onChange={handlePendingYearChange}
                            onKeyDown={handleAnioKeyDown}
                            inputProps={{
                              maxLength: 4,
                              inputMode: "numeric",
                              pattern: "[0-9]*",
                            }}
                            sx={{
                              minWidth: { xs: "10%", sm: 100 },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm="auto">
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={handleBuscarPeriodo}
                          >
                            Buscar
                          </Button>
                        </Grid>
                      </Grid>
                    </>
                  )}
                  layoutMode="grid"
                  localization={MRT_Localization_ES}
                  enableColumnDragging={false} //No permite que se arrastren las columnas.
                  enableEditing
                  enableGrouping
                  positionToolbarAlertBanner="none"
                  // ACCIONES
                  renderToolbarInternalActions={(
                    { table } // boton para nuevo , al lado del buscar
                  ) => (
                    <>
                      <MRT_FullScreenToggleButton table={table} />
                    </>
                  )}
                  renderRowActions={(
                    { row } //las acciones del costado editar y ver
                  ) => (
                    <div>
                      <Tooltip title="Ver Control">
                        <IconButton
                          onClick={() => handleClickMostrar(row.original)}
                          color="primary"
                        >
                          <AssignmentIcon />
                        </IconButton>
                      </Tooltip>
                      {esAuditor === "1" && row.original.auditado === "No" ? (
                        <Tooltip title="Revisar">
                          <IconButton
                            onClick={() => {
                              setRevision(!revision);
                              setChecklistRow(row.original);
                            }}
                            color="primary"
                          >
                            <CheckIcon />
                          </IconButton>
                        </Tooltip>
                      ) : null}
                    </div>
                  )}
                />
              </ThemeProvider>
              <br />
              <br />
            </Box>
          ) : null}
        </Container>
      ) : null}

      {mostrarResultadoCheck ? (
        <Resultado_tabla
          tabla={setTabla}
          mostrarResultadoCheck={mostrarResultadoCheck}
          datosResultados={datosResultados}
          onClose={() => handleVolverMostrar()}
        />
      ) : null}

      {revision ? (
        <Dialog_revision
          revision={revision}
          row={checklistRow}
          datosResultados={datosResultados}
          onClose={handleVolverMostrar}
        />
      ) : null}
    </div>
  );
}

export default Tabla_check;